module.exports = __webpack_public_path__ + "img/empty.966795c6.png";